import { NotificationSource } from '@layout/notifications/models/notification-source.enum';
import { ZendeskSsoRequestInfo } from '@core/sso/models/zendesk/zendesk-sso-request-info.interface';

const actionScope = '[Notifications]';

export class LoadNotifications {
  static readonly type = `${actionScope} Load Notifications`;

  constructor(public withLoading = true) {}
}

export class LoadUnreadNotificationsCount {
  static readonly type = `${actionScope} Load Unread Notifications Count`;
}

export class StartListeningNotifications {
  static readonly type = `${actionScope} Start Listen Notifications`;
}

export class StopListeningNotifications {
  static readonly type = `${actionScope} Stop Listen Notifications`;
}

export class SetNotificationsVisibility {
  static readonly type = `${actionScope} Set Notifications Visibility`;

  constructor(public areNotificationsVisible: boolean) {}
}

export class MarkAllNotificationsAsViewed {
  static readonly type = `${actionScope} Mark All Notifications As Viewed`;
}

export class ToggleNotificationViewability {
  static readonly type = `${actionScope} Toggle Notification Viewability`;

  constructor(
    public notificationId: string,
    public source: NotificationSource,
    public viewed: boolean
  ) {}
}

export class DeleteAllNotifications {
  static readonly type = `${actionScope} Delete All Notifications`;
}

export class DeleteNotification {
  static readonly type = `${actionScope} Delete Notification`;

  constructor(
    public notificationId: string,
    public source: NotificationSource
  ) {}
}

export class LoadZendeskSsoRequestInfo {
  static readonly type = `${actionScope} Load Zendesk Sso Request Info`;

  constructor(public ticketId: string) {}
}

export class LoadZendeskSsoRequestInfoSuccess {
  static readonly type = `${actionScope} Load Zendesk SsoRequest Info Success`;

  constructor(public zendeskSsoRequestInfo: ZendeskSsoRequestInfo) {}
}
